"use client"
import { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useLanguage } from "../contexts/LanguageContext"
import { useApartments } from "../contexts/aparts/useApartments"
import FilterBar from "./FilterBar"
import { StaggeredReveal } from "./ScrollReveal"
import { motion } from "framer-motion"

const ApartmentListings = () => {
  const { t, language } = useLanguage()
  const navigate = useNavigate()
  const [filteredApartments, setFilteredApartments] = useState([])
  const [activeFilters, setActiveFilters] = useState({
    priceRange: "",
    guests: ""
  })

  // Get apartments from context instead of hardcoded data
  const apartments = useApartments()

  // פונקציה לסינון דירות לפי הפילטרים הפעילים
  const filterApartments = () => {
    let results = [...apartments];
    
    // סינון לפי טווח מחירים
    if (activeFilters.priceRange) {
      if (activeFilters.priceRange === "0-100") {
        results = results.filter(apt => apt.price >= 0 && apt.price <= 100);
      } else if (activeFilters.priceRange === "100-200") {
        results = results.filter(apt => apt.price > 100 && apt.price <= 200);
      } else if (activeFilters.priceRange === "200-300") {
        results = results.filter(apt => apt.price > 200 && apt.price <= 300);
      } else if (activeFilters.priceRange === "300+") {
        results = results.filter(apt => apt.price > 300);
      }
    }
    
    // סינון לפי מספר אורחים
    if (activeFilters.guests) {
      if (activeFilters.guests === "4+") {
        results = results.filter(apt => apt.guests >= 4);
      } else {
        results = results.filter(apt => apt.guests === parseInt(activeFilters.guests));
      }
    }
    
    return results;
  };
  
  // עדכון הדירות המסוננות בכל פעם שהפילטרים משתנים
  useEffect(() => {
    setFilteredApartments(filterApartments());
  }, [activeFilters]);
  
  // אתחול הדירות המסוננות בטעינה הראשונית
  useEffect(() => {
    setFilteredApartments(apartments);
  }, []);
  
  // טיפול בשינוי פילטרים
  const handleFilterChange = (newFilters) => {
    setActiveFilters(newFilters);
  };

  return (
    <>
      <FilterBar onFilterChange={handleFilterChange} />
      <section id="apartments" className="apartments">
        <div className="container">
          {filteredApartments.length === 0 ? (
            <div className="no-results">
              <h3>{t("noApartmentsFound")}</h3>
              <p>{t("tryDifferentFilters")}</p>
            </div>
          ) : (
            <StaggeredReveal className="apartments-grid" staggerDelay={0.15} initialDelay={0.2} direction="up" distance={30}>
              {filteredApartments.map((apartment) => (
                <motion.div 
                  key={apartment.id} 
                  className="apartment-card" 
                  onClick={() => navigate(`/apartment/${apartment.id}`)}
                  style={{ cursor: 'pointer' }}
                  whileHover={{ 
                    y: -10,
                    boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
                    transition: { duration: 0.3 }
                  }}
                >
                  <div className="apartment-image">
                    <img 
                      src={apartment.images?.[0] || apartment.image || "/placeholder.svg"} 
                      alt={apartment[`title${language.charAt(0).toUpperCase() + language.slice(1)}`] || apartment.titleEn} 
                    />
                  </div>
                  <div className="apartment-content">
                    <h3 className="apartment-title">
                      {apartment[`title${language.charAt(0).toUpperCase() + language.slice(1)}`] || apartment.titleEn}
                    </h3>
                    <p className="apartment-description">
                      {apartment[`description${language.charAt(0).toUpperCase() + language.slice(1)}`] || apartment.descriptionEn}
                    </p>
                    <div className="apartment-details">
                      <div className="detail">
                        <span className="detail-number bedrooms-number">{apartment.bedrooms}</span>
                        <span className="detail-label">{t("bedrooms")}</span>
                      </div>
                      <div className="detail">
                        <span className="detail-number size-number">
                          {apartment.size}
                        </span>
                        <span className="detail-label">{t("sqm")}</span>
                      </div>
                      <div className="detail">
                        <span className="detail-number guests-number">{apartment.guests}</span>
                        <span className="detail-label">{t("guests")}</span>
                      </div>
                    </div>
                    <motion.button 
                      className="view-details-btn" 
                      onClick={(e) => {
                        e.stopPropagation(); // מונע הפעלה כפולה
                        navigate(`/apartment/${apartment.id}`);
                      }}
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                    >
                      {t("viewDetails")}
                    </motion.button>
                  </div>
                </motion.div>
              ))}
            </StaggeredReveal>
          )}
        </div>
      </section>
    </>
  )
}

export default ApartmentListings
